import React from 'react';
import Block from '../../../../../components/Block';
import Text from '../../../../../components/Text';
import { Icon } from '../../../../../components';
import { WrapWarning } from '../styles';

const Warning = (props: any) => {
  const { message } = props;
  return (
    <>
      <WrapWarning>
        <Block
          customized
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          maxWidth="16px"
          margin="0px 4px 0px 0px"
        >
          <Icon name="alert-triangle" size={16} />
        </Block>
        <Block
          customized
          display="flex"
          justifyContent="center"
          alignItems="flex-start"
          flexDirection="column"
        >
          <Text
            fontSize="12px"
            lineHeight="16px"
            fontWeight="400"
            color="#E8212B"
          >
            {message}
          </Text>
        </Block>
      </WrapWarning>
    </>
  );
};

export default Warning;
